module.exports = __webpack_public_path__ + "img/tiktok.f6d4517e.png";